var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: '100%', height: '280px'}),attrs:{"id":"echart-multibar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }